import { gql, useMutation } from "@apollo/client";
import React, { useState } from "react";
import { Button, Form, Grid, Segment } from "semantic-ui-react";
import Swal from "sweetalert2";
import LOGO_MULTI from "../../assets/logo-multi.png";
import InputTypePassword from "../../Components/InputTypePassword";
import { PASSWORD_REGEX } from "../../Utils/Constants";
const passwordError = 'La contraseña debe tener mínimo entre 8 y 15 caracteres, una letra minúscula, una mayúscula, un número y un carácter especial.';

const RecoverPassword = ({ location, history }) => {
  let params = (new URLSearchParams(location?.search));
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  let validateToken = params.get('validateToken') || "";

  const onCompleted = () => {
    setLoading(false);
    Swal.fire('Su contraseña se actualizó exitosamente.', '', 'success')
      .then(() => history.replace("/"))
  }

  const onError = ({ graphQLErrors }) => {
    setLoading(false);
    if (graphQLErrors) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: graphQLErrors[0]?.message
      });
    } else {
      Swal.fire("Lo sentimos, ha ocurrido un error.");
    }
  };

  const validatePassword = () => {
    if (password.trim() && !PASSWORD_REGEX.test(password)) return passwordError;
    return null;
  }


  const [mutation] = useMutation(RECOVER_PASSWORD, { onCompleted, onError });
  const handleMutation = () => {
    const variables = {
      newPassword: password,
      validateToken
    };
    mutation({ variables });
  }
  return (
    <Grid className="login" textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
      <Grid.Column style={{ maxWidth: 450 }}>
        <Form size='large'>
          <Segment stacked>
            <div style={{ textAlign: 'center' }}>
              <img src={LOGO_MULTI} alt="logo multidiomas" />
            </div>
            <h3>Nueva contraseña </h3>
            <InputTypePassword
              label="Nueva contraseña"
              placeholder="Contraseña *"
              value={password}
              error={validatePassword() || password !== repeatPassword}
              required
              onChange={(e, { value }) => setPassword(value)} />
            <InputTypePassword
              label="Repetir contraseña"
              placeholder="Repetir contraseña *"
              error={password !== repeatPassword}
              value={repeatPassword}
              required
              onChange={(e, { value }) => setRepeatPassword(value)} />
            <Button
              onClick={handleMutation}
              disabled={!PASSWORD_REGEX.test(password) || !password.trim() || password.trim() !== repeatPassword.trim() || loading}
              style={{ backgroundColor: '#B0193F', color: '#fff' }}>
              Enviar
          </Button>
            <Button
              onClick={() => history.replace('/')}
              style={{ backgroundColor: '#B0193F', color: '#fff' }}>
              Volver
          </Button>
          </Segment>
        </Form>
      </Grid.Column>
    </Grid>
  )
}

const RECOVER_PASSWORD = gql`
  mutation recoverPassword($newPassword: String!, $validateToken: String!) {
    cambiarContrasenaToken(
      newPassword: $newPassword
      validateToken: $validateToken
    )
  }
`;

export default RecoverPassword;